export default {
  name: 'house_number_valid_characters',
  validate: (value: string | null): boolean => {
    if (!value) {
      return true;
    }

    return /^[a-zA-Z0-9 /-]{1,8}$/.test(value)
  }
};
